<template>
    <customModal :containermd="true" @closeModal="closeModal">
        <template #title>
            {{ isEditMode ? 'Edit Task' : 'Add Task' }} — {{ mitigationCode }}
        </template>
        <template #body>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group mb-3">
                        <label class="mb-0">Task ID <sup ><i class="fa fa-asterisk required"></i></sup></label>
                        <input type="text" class="form-control" v-model="form.taskId"
                            :disabled="isEditMode" />
                        <small class="errorClass" v-if="errors.taskId">{{ errors.taskId }}</small>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="form-group mb-3">
                        <label class="mb-0">Assigned Role</label>
                        <Multiselect
                            v-model="form.owner"
                            mode="single"
                            valueProp="roleID"
                            label="roleName"
                            placeholder="Select owner role"
                            :options="roleList"
                            :hide-selected="false"
                            :close-on-select="true"
                            :searchable="true"
                            class="multiselect-theme">
                            <template #option="{ option }">
                                {{ option.roleName }}
                            </template>
                        </Multiselect>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="form-group mb-3">
                        <label class="mb-0">Cadence</label> 
                        <select class="form-control" v-model="form.cadence">
                            <option value="">Select</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Ongoing">Ongoing</option>
                            <option value="Per ECG Event">Per ECG Event</option>
                            <option value="Per Event">Per Event</option>
                            <option value="Per Visit">Per Visit</option>
                        </select>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group mb-3">
                        <label class="mb-0">Task Description</label>
                        <textarea class="form-control" v-model="form.taskDescription" rows="4" />
                    </div>
                </div>

                <div class="col-12 text-end mt-2">
                    <button class="cancel_btn px-4 py-1" @click="clearForm">Clear</button>&nbsp;
                    <button class="save_btn px-4 py-1" @click="save" :disabled="saving">
                        <span v-if="saving"><img src="@/assets/img/loading.gif" width="12" /> Saving...</span>
                        <span v-else>{{ isEditMode ? 'Update' : 'Save' }}</span>
                    </button>
                </div>
            </div>
        </template>
    </customModal>
</template>

<script src="./ManageMitigationTaskModal.js"></script>

<style>
.multiselect-theme {
    --ms-option-bg-selected-pointed: rgb(210, 210, 210);
    --ms-option-bg-selected: rgb(210, 210, 210);
    --ms-option-color-selected: #000;
    --ms-option-color-selected-pointed: #000;
}
</style>